module.exports = __webpack_public_path__ + "img/patient-evaluation.30afb27c.svg";